import React from "react";
import "./index.scss"
class Radio extends React.Component {
    render() {
        return <div className={`${this.props.className ? this.props.className + " radio" : "radio"}`} onClick={this.props.onClick}>
            <div className={`point ${this.props.isSelect ? 'active-radio' : ''}`}></div>
            <div className="text">{this.props.children}</div>
        </div>
    }
}

export default Radio